import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{ns}}/{{lng}}.json"
    },
    fallbackLng: "en",
    //disable in production
    debug: false,
    //can use multiple namespaces, in case you want to divide a huge translation 
    //into smaller pieces and load them on demand
    ns: ["i18n"],

    interpolation : {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true
    }
  });
export default i18n;